<h1 class="u-sr-only">{{ 'Profile.Menu.Create_Employee_Surveys' | translate }}</h1>
<section class="c-section c-section--last u-no-pb" panel [isOpen]="true">
    <div class="c-section__header">
        <p class="c-section__title u-hidden@md-and-up">{{ 'Profile.Menu.Create_Employee_Surveys' | translate }}</p>
    </div>
    <div class="c-section__content">
        <div class="o-grid">
            <div class="o-grid__cell c-cell">
	                <card-employee-surveys [questionnaireCode]="vm.surveyCode" [pulseContext]="vm.pulseContext"></card-employee-surveys>
            </div>
        </div>
    </div>
</section>
